// removed by extract-text-webpack-plugin
module.exports = {"enter":"slide-right__enter___8bk-m","leave":"slide-right__leave___3NliL","enterActive":"slide-right__enterActive___3pxpZ","leaveActive":"slide-right__leaveActive___3spKq"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/animations/slide-right.scss
// module id = 1030
// module chunks = 0